@if (haveAccessToModule('users')) {
  <button mat-raised-button  routerLinkActive="active" [routerLink]="['/users']">Users</button>
}
<button mat-raised-button  routerLinkActive="active" [routerLink]="['/products']">Products</button>
<button mat-raised-button  routerLinkActive="active" [routerLink]="['/factories']" >Factories</button>
@if (haveAccessToModule('parameters')) {
  <button mat-raised-button  routerLinkActive="active" [routerLink]="['/parameters']">Parameters Setting</button>
}
@if (haveAccessToModule('agreements')) {
  <button mat-raised-button  routerLinkActive="active" [routerLink]="['/agreements']">General Agreement</button>
}
@if (haveAccessToModule('matrix')) {
  <button mat-raised-button  routerLinkActive="active" [routerLink]="['/matrix']">Matrix</button>
}
